module.exports = __webpack_public_path__ + "static/media/CircularStd-Bold.961a181d.ttf";